import Grid from "@mui/material/Grid2";
import FileExplorer from "./FileExplorer";
import Paper from "@mui/material/Paper";
import { AuthContext } from "../Authorisation/AuthContext";
import { useContext } from "react";

export default function MyFilesContainer() {
    const { userDetails } = useContext(AuthContext);
    return (
        <Grid container>
            <Grid size={6} component={Paper}>
                <FileExplorer title="My Files" container="files" rootPath={`/${userDetails?.userId}/`} />
            </Grid>
        </Grid>
    );
}